import { render, staticRenderFns } from "./TypingBubble.vue?vue&type=template&id=46d634b5&"
import script from "./TypingBubble.vue?vue&type=script&lang=js&"
export * from "./TypingBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports